import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createBooking = (payload) =>
  apiClient.post("/bookings", payload).then((r) => r.data);

export const sendContact = (payload) =>
  apiClient.post("/contact", payload).then((r) => r.data);

export const fetchReviews = () =>
  apiClient.get("/reviews").then((r) => r.data);

export const submitReview = (payload) =>
  apiClient.post("/reviews", payload).then((r) => r.data);

export const fetchUnavailableDates = () =>
  apiClient.get("/bookings/unavailable-dates").then((r) => r.data.dates || []);

export const fetchAdminBookings = (token) =>
  apiClient.get(`/bookings?token=${encodeURIComponent(token)}`).then((r) => r.data);
